import { useTypedQuery } from "hooks/useTypedQuery";
import { useManufacturerDashboardFilters } from "modules/ManufacturerDashboard/hooks";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PaginatedManufacturerRequests } from "modules/ManufacturerDashboard/queryKeys";

const sortPaginatedManufacturerRequests = (paginatedRequest: PaginatedManufacturerRequests) => {
  paginatedRequest.manufacturer_requests.sort((a, b) => b.id - a.id);
  paginatedRequest.manufacturer_requests.forEach(mr => mr.pin_history?.sort((a, b) => b.id - a.id));

  return paginatedRequest;
};

export const useManufacturerRequestsQuery = () => {
  const filters = useManufacturerDashboardFilters();

  const query = useTypedQuery({
    queryKey: ManufacturerQueryKeys.manufacturerListRequests(filters),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    select: sortPaginatedManufacturerRequests
  });

  return { manufacturerRequests: query.data, isFetching: query.isFetching, refetch: query.refetch };
};
